module.exports = __webpack_public_path__ + "img/vip-day.de9ce2ad.jpg";